import {
    ShieldCheck,
    Clock,
    Sparkles,
    BadgePoundSterling,
    UserCheck,
    MessageCircle,
} from "lucide-react";

const REASONS = [
    {
        icon: ShieldCheck,
        title: "Reliable and trustworthy",
        desc: "Turn up when we say we will, do what we said we&rsquo;d do — and clean up after.",
    },
    {
        icon: BadgePoundSterling,
        title: "Honest, upfront pricing",
        desc: "Clear quotes before any work starts. No surprise add-ons at the end of the job.",
    },
    {
        icon: UserCheck,
        title: "One tradesman, one job",
        desc: "You deal with the person doing the work — not a call centre or a middleman.",
    },
    {
        icon: Clock,
        title: "On time, every time",
        desc: "We respect your time. If something changes, we&rsquo;ll always let you know first.",
    },
    {
        icon: Sparkles,
        title: "Tidy workmanship",
        desc: "We finish properly and leave your home as clean as we found it.",
    },
    {
        icon: MessageCircle,
        title: "Easy to deal with",
        desc: "Friendly, straightforward, and happy to explain anything along the way.",
    },
];

export default function WhyChooseUs() {
    return (
        <section
            id="why-us"
            data-testid="why-us-section"
            className="relative py-24 md:py-32 bg-slate-900 text-white overflow-hidden"
        >
            <div className="absolute inset-0 bg-grid-dark opacity-80 pointer-events-none" />
            <div className="absolute -bottom-40 -left-32 w-[500px] h-[500px] rounded-full bg-amber-600/10 blur-3xl pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-5">
                        <div className="text-xs uppercase tracking-[0.2em] text-amber-400 font-bold mb-4">
                            Why choose us
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight">
                            Built on trust, finished
                            <br />
                            with{" "}
                            <span className="text-amber-400">pride.</span>
                        </h2>
                        <p className="mt-6 text-lg text-slate-300 leading-relaxed max-w-md">
                            Hiring a handyman shouldn&apos;t be stressful.
                            We&apos;ve built our reputation in Dumbarton on
                            being the kind of tradesman you&apos;d happily
                            recommend to a friend.
                        </p>
                    </div>

                    <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {REASONS.map(({ icon: Icon, title, desc }) => (
                            <div
                                key={title}
                                data-testid={`why-card-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                className="p-6 rounded-xl bg-white/[0.04] border border-white/10 hover:bg-white/[0.07] hover:border-amber-400/40 transition-all"
                            >
                                <div className="w-10 h-10 rounded-md bg-amber-500/15 border border-amber-400/30 flex items-center justify-center mb-4">
                                    <Icon className="w-5 h-5 text-amber-400" />
                                </div>
                                <h3 className="font-display text-lg font-bold">
                                    {title}
                                </h3>
                                <p
                                    className="mt-2 text-sm text-slate-300 leading-relaxed"
                                    dangerouslySetInnerHTML={{
                                        __html: desc,
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
